module.exports = __webpack_public_path__ + "img/projects-details-1.716de9c2.jpg";